import React from 'react';
import { Nav, Container, Row, Col } from 'react-bootstrap';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUser, 
  faEnvelope, 
  faCreditCard, 
  faLock,
  faBuilding
} from '@fortawesome/free-solid-svg-icons';

const SettingsLayout = () => {
  const location = useLocation();
  
  const settingsNav = [
    {
      path: '/settings/subscription-settings',
      label: 'Subscription',
      icon: faCreditCard,
      description: 'Manage your plan and billing'
    },
    {
      path: '/settings/profile-settings',
      label: 'Profile',
      icon: faUser,
      description: 'Update your personal information'
    },
    {
      path: '/settings/email-settings',
      label: 'Email',
      icon: faEnvelope,
      description: 'Configure email integrations'
    },
    {
      path: '/settings/security-settings',
      label: 'Security',
      icon: faLock,
      description: 'Password and security options'
    },
    {
      path: '/settings/onboarding',
      label: 'Company',
      icon: faBuilding,
      description: 'Company settings and onboarding'
    }
  ];

  return (
    <Container fluid className="px-0">
      <Row className="g-0">
        <Col lg={3} xl={2} className="border-end bg-light min-vh-100">
          <div className="p-3">
            <h5 className="mb-4">Settings</h5>
            <Nav className="flex-column">
              {settingsNav.map((item) => (
                <Nav.Item key={item.path} className="mb-2">
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `nav-link d-flex align-items-center p-3 rounded-2 text-decoration-none ${
                        isActive ? 'bg-primary text-white' : 'text-dark'
                      }`
                    }
                  >
                    <FontAwesomeIcon 
                      icon={item.icon} 
                      className="me-3" 
                      style={{ width: '20px' }}
                    />
                    <div>
                      <div className="fw-semibold">{item.label}</div>
                      <small className={location.pathname === item.path ? 'text-white-50' : 'text-muted'}>
                        {item.description}
                      </small>
                    </div>
                  </NavLink>
                </Nav.Item>
              ))}
            </Nav>
          </div>
        </Col>
        <Col lg={9} xl={10}>
          <div className="p-4">
            <Outlet />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default SettingsLayout;